import { css } from '@emotion/core';
import { WeaveTheme } from '@weave/theme-original';

export const sectionContainerStyles = (theme: WeaveTheme) => css`
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.gray['200']};
  border: 1px solid ${theme.colors.gray['300']};
  border-radius: ${theme.borderRadius.small};
  flex: 1;
  max-width: 500px;
`;
